export const ROOT = '/';
export const SHARE_ROUTE = '/share';
